import React from "react";
import { Box, type BoxProps, Text } from "@chakra-ui/react";
import { AlgoliaSearchFilters, capitalizeLabel } from "components/algolia";

export const typeAttribute = "type";
export const categoryAttribute = "categories.name";

type SidebarFiltersProps = {
  query: string;
  headerHeight: string;
  onFilterChanged: () => void;
} & Pick<BoxProps, "pt">;

function IntegrationsSidebarFilters({ query, headerHeight, onFilterChanged, pt }: SidebarFiltersProps) {
  return (
    <Box as="aside" display={["none", "none", "none", "initial"]} w="22%" position="sticky" top={headerHeight} pt={pt}>
      <Box minH={0} maxH={`calc(100vh - ${headerHeight})`} display="flex" flexDirection="column">
        <Box flex="none">
          <Text fontWeight="semibold" fontSize="brand.md" mb="smaller" ml="tiniest">
            Integration type
          </Text>
          <AlgoliaSearchFilters
            attribute={typeAttribute}
            query={query}
            transformItems={capitalizeLabel}
            onFilterChanged={onFilterChanged}
          />
          <Text fontWeight="semibold" fontSize="brand.md" mb="smaller" ml="tiniest">
            Category
          </Text>
        </Box>
        <Box overflowY="auto" flex="1" minHeight={0} mb="bigger">
          <AlgoliaSearchFilters attribute={categoryAttribute} query={query} onFilterChanged={onFilterChanged} />
        </Box>
      </Box>
    </Box>
  );
}

export default IntegrationsSidebarFilters;
